/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
    Button,
    Modal,
    Form as FormUi,
    Input,
    Checkbox,
    Dropdown,
    Grid,
    Image
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import moment from "moment";
import {
    successAlertDispatcher,
    errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import ViewDetails from "../common/viewDetails";
import ReadAxios from "../axiosComponent/read";

const OrderDetailsInvoice = ({
    values,
    touched,
    errors,
    isSubmitting,
    handleSubmit,
    setFieldValue,
    t,
    modalOpen,
    handleClose,
    viewModeData,
    orderData
}) => {
    let [loading, setLoading] = useState(false);
    let [orderDetails, setOrderDetails] = useState({});
    let [shipmentDetails, setShipmentDetails] = useState({});
    let [deliveryDetails, setDeliveryDetails] = useState({});
    let [loadTypeDetails, setLoadTypeDetails] = useState({});
    let [invoiceDetails, setInvoiceDetails] = useState([]);
    let [productDetails, setProductDetails] = useState([]);
    let [consignorDetails, setConsignorDetails] = useState([]);
    let [consigneeDetails, setConsigneeDetails] = useState([]);

    useEffect(() => {
        console.log("+++++++++++++++++++ORDER DETAIL INVOICE++++++++++++++++++++");
        setOrderDetails(orderData)
        setShipmentDetails(orderData.shipment)
        if (orderData.deliveries && orderData.deliveries.length > 0) {
            setDeliveryDetails(orderData.deliveries[0])
            setLoadTypeDetails(orderData.load_type)
            setInvoiceDetails(orderData.deliveries[0].invoices)
            setProductDetails(orderData.deliveries[0].products)
            setConsignorDetails(orderData.deliveries[0].consignor)
            setConsigneeDetails(orderData.deliveries[0].consignee)
        }
    }, [orderData]);

    const columnDefsInvoice = [
        {
            headerName: "Invoice No",
            field: "invoice_no",
        },
        {
            headerName: "Invoice",
            field: "invoice_code",
        },
        {
            headerName: "Weight (in kgs)",
            field: "invoice_quantity",
        },
        {
            headerName: "Invoice Date",
            field: "invoice_date",
            valueFormatter: function (params) {
                return params.value ? moment(params.value).format("DD-MM-yyyy") : "Na";
            }
        },
        {
            headerName: "Total Invoice Value",
            field: "invoice_amount",
        },
    ]

    const columnDefsProductDetails = [
        {
            headerName: "Product Code",
            field: "order_no",
        },
        {
            headerName: "Product Name",
            field: "product_category_name",
        },
        {
            headerName: "Product Category",
            field: "product_category_name",
        },
        {
            headerName: "Quantity",
            field: "quantity",
        },
        {
            headerName: "Package Type",
            field: "packaging_type_name",
        },
        {
            headerName: "Rate",
            field: "order_no",
        },
    ]

    return (
        <div>
            <Modal open={modalOpen} onClose={handleClose} size="fullscreen">
                <Modal.Header className="p-bold-100">
                    <div className="d-flex justify-content-between">
                        <label className="font-weight-normal">{"Order Details"}</label>
                        <div className="form-inline">
                            <i onClick={handleClose} className="fas fa-times"></i>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Content>
                    <div className="ag-theme-material agOver">

                        {/* VEHICLE DETAILS */}
                        <div className="order-detail-invoice_vehicle padding-bottom-20 padding-top-20">
                            <Grid divided='vertically'>
                                <Grid.Row columns={3}>
                                    <Grid.Column>
                                        <div className="display-flex-center-justify-spacebtwn">
                                            <div className="order-detail-invoice-label">Booking Branch</div><div>{orderDetails.booking_branch_name}</div></div>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <div className="display-flex-center-justify-spacebtwn">
                                            <div className="order-detail-invoice-label">Load Type</div>
                                            <div>{loadTypeDetails?.load_type_name}</div></div>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={3}>
                                    <Grid.Column>
                                        <div className="display-flex-center-justify-spacebtwn">
                                            <div className="order-detail-invoice-label">Temperature Minimum</div>
                                            <div>{orderDetails.min_temp}</div></div>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <div className="display-flex-center-justify-spacebtwn">
                                            <div className="order-detail-invoice-label">Temperature Maximum</div>
                                            <div>{orderDetails.max_temp}</div></div>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={3}>
                                    <Grid.Column>
                                        <div className="display-flex-center-justify-spacebtwn">
                                            <div className="order-detail-invoice-label">Ownership Type</div>
                                            <div>{orderDetails.ownership_type_name}</div></div>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <div className="display-flex-center-justify-spacebtwn">
                                            <div className="order-detail-invoice-label">Weight</div>
                                            <div>{orderDetails.gross_weight}</div></div>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={3}>
                                    <Grid.Column>
                                        <div className="display-flex-center-justify-spacebtwn">
                                            <div className="order-detail-invoice-label">Vendor</div><div>{orderDetails.vendor_name}</div></div>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <div className="display-flex-center-justify-spacebtwn">
                                            <div className="order-detail-invoice-label">Required Vehicle Type</div>
                                            <div>{orderDetails.vehicle_type}</div></div>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </div>

                        {/* DELIVERY DETAILS */}
                        <div className="order-detail-invoice-container padding-bottom-20">
                            <div className="padding-left-0 border-bottom-invoice-heading">
                                <h3 className="padding-left-10 order-detail-invoice-heading">Delivery</h3>
                            </div>
                            <div className="order-detail-invoice_delivery padding-left-10 padding-bottom-20 padding-top-20">
                                <Grid divided='vertically'>
                                    <Grid.Row columns={3}>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">LR Number</div><div>{deliveryDetails.lr_no}</div></div>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">LR Date</div>
                                                <div>
                                                    {deliveryDetails?.lr_date ?
                                                        <>{moment(deliveryDetails.lr_date).format("DD-MM-YYYY HH:mm")}</>
                                                        : <>-</>}
                                                </div>
                                            </div>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row columns={3}>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">Consignor</div><div>{consignorDetails.name}</div></div>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">Consignee</div><div>{consigneeDetails.name}</div></div>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row columns={3}>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">Consignor Address</div><div>{consignorDetails.consignor_address}</div></div>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">Consignee Address</div><div>{consigneeDetails.consignee_address}</div></div>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row columns={3}>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">Consignor City</div><div>{consignorDetails.consignor_city}</div></div>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">Consignee City</div><div>{consigneeDetails.consignee_city}</div></div>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row columns={3}>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">Billing Party</div><div>{deliveryDetails.billing_party_name}</div></div>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">Billing Party Branch</div><div>{deliveryDetails.billing_party_branch_name}</div></div>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row columns={3}>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">Customer Type</div><div>{deliveryDetails.customer_type_name}</div></div>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </div>

                            <div className="order-detail-invoice_transit padding-left-10 padding-right-10 padding-bottom-20 padding-top-20">
                                <Grid divided='vertically'>
                                    <Grid.Row columns={3}>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">Scheduled Pickup Date</div>
                                                <div>
                                                    {deliveryDetails?.container_pickup_date ?
                                                        <>{moment(deliveryDetails.container_pickup_date).format("DD-MM-YYYY HH:mm")}</>
                                                        : <>-</>}
                                                </div>
                                            </div>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">Actual Pickup Date</div>
                                                <div>{deliveryDetails?.actual_pickup_date ?
                                                    <>{moment(deliveryDetails.actual_pickup_date).format("DD-MM-YYYY HH:mm")}</>
                                                    : <>-</>}
                                                </div>
                                            </div>
                                        </Grid.Column>
                                        <Grid.Column>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row columns={3}>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">Scheduled Delivery Date</div>
                                                <div>
                                                    {deliveryDetails?.delivery_date ?
                                                        <>{moment(deliveryDetails.delivery_date).format("DD-MM-YYYY HH:mm")}</>
                                                        : <>-</>}
                                                </div>
                                            </div>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <div className="display-flex-center-justify-spacebtwn"><div className="order-detail-invoice-label">Actual Delivery Date</div>
                                                <div>
                                                    {deliveryDetails?.actual_delivery_date ?
                                                        <>{moment(deliveryDetails.actual_delivery_date).format("DD-MM-YYYY HH:mm")}</>
                                                        : <>-</>}
                                                </div>
                                            </div>
                                        </Grid.Column>
                                        <Grid.Column>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </div>

                        </div>

                        {/* INVOICE DETAILS */}
                        <div className="order-detail-invoice-container order-detail-invoice-container_posn-sft padding-bottom-20">
                            <div className="padding-left-0 border-bottom-invoice-heading">
                                <h3 className="padding-left-10 order-detail-invoice-heading">Invoice</h3>
                            </div>
                            <div className="padding-left-10">
                                <AgGridReact
                                    domLayout="autoHeight"
                                    columnDefs={columnDefsInvoice}
                                    loading={loading}
                                    rowData={invoiceDetails}
                                ></AgGridReact>
                            </div>
                        </div>

                        {/* PRODUCT DETAILS */}
                        <div className="order-detail-invoice-container order-detail-invoice_product_details padding-bottom-20">
                            <div className="padding-left-0 border-bottom-invoice-heading">
                                <h3 className="padding-left-10 order-detail-invoice-heading">Product Details</h3>
                            </div>
                            <div className="padding-left-10">

                                <AgGridReact
                                    domLayout="autoHeight"
                                    columnDefs={columnDefsProductDetails}
                                    loading={loading}
                                    rowData={productDetails}
                                ></AgGridReact>
                            </div>
                        </div>
                    </div>
                </Modal.Content>
            </Modal>
        </div>
    );
};

export default OrderDetailsInvoice;